var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.rating)?_c('b-badge',{staticClass:"badge-glow",attrs:{"variant":_vm.variant}},[_vm._v(" "+_vm._s(_vm.rating))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }